"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mountSlackOnboardingBanner = void 0;
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var SlackAdditionalInfo = (0, mobx_react_1.observer)(function () {
    return (react_1.default.createElement(kaleidoscope_1.Card, null,
        react_1.default.createElement(kaleidoscope_1.RainbowBar, null),
        react_1.default.createElement(kaleidoscope_1.Stack, { className: "space-stack-l" },
            react_1.default.createElement(kaleidoscope_1.Stack, { className: "space-inset-m" },
                react_1.default.createElement(kaleidoscope_1.Stack, { className: "space-stack-s" },
                    react_1.default.createElement(kaleidoscope_1.Label, { size: "l", align: "left" }, "Get Started")),
                react_1.default.createElement(kaleidoscope_1.Stack, { className: "space-stack-xs" },
                    react_1.default.createElement(kaleidoscope_1.Text, { size: "s", align: "left" },
                        "Manage your Slack automations in your ",
                        react_1.default.createElement(kaleidoscope_1.Link, { href: "/#/automations" }, "automations library"),
                        "."))))));
});
var mountSlackOnboardingBanner = function (mountReactComponent) {
    return mountReactComponent(react_1.default.createElement(SlackAdditionalInfo, null));
};
exports.mountSlackOnboardingBanner = mountSlackOnboardingBanner;
